import script from "./HowItWorksSection.vue?vue&type=script&setup=true&lang=js"
export * from "./HowItWorksSection.vue?vue&type=script&setup=true&lang=js"

import "./HowItWorksSection.vue?vue&type=style&index=0&id=e9213daa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9213daa"]])

export default __exports__